"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function cov_w317t8g3u() {
  var path = "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/resaleAvailability/lib/model.js";
  var hash = "cf9ceda1f70f292c67e2f180a3713d8d0bf3a4cb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/resaleAvailability/lib/model.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 32
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 3,
          column: 31
        },
        end: {
          line: 10,
          column: 5
        }
      },
      "2": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 7
          },
          end: {
            line: 2,
            column: 8
          }
        },
        loc: {
          start: {
            line: 2,
            column: 15
          },
          end: {
            line: 13,
            column: 3
          }
        },
        line: 2
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "cf9ceda1f70f292c67e2f180a3713d8d0bf3a4cb"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_w317t8g3u = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_w317t8g3u();
var ResaleAvailabilityModel = (cov_w317t8g3u().s[0]++, {
  get: function get(data) {
    cov_w317t8g3u().f[0]++;
    var resaleAvailability = (cov_w317t8g3u().s[1]++, {
      isDisplayResaleLink: data.displayResaleLink,
      resaleProductUrl: data.resaleProductUrl,
      resalePassUrl: data.resalePassUrl,
      resalePerformanceUrl: data.resalePerformanceUrl,
      supportedProductTypes: data.supportedProductTypes,
      supportedProductFamilySubTypes: data.supportedProductFamilySubTypes
    });
    cov_w317t8g3u().s[2]++;
    return resaleAvailability;
  }
});
var _default = exports.default = ResaleAvailabilityModel;